import { Box, Flex, Pagination, Select } from '@mantine/core';

export type FooterRowProps = {
  page?: number;
  pageSize?: number;
  setPageSize?: (pageSize: number) => void;
  total?: number;
  setPage?: (page: number) => void;
};

export const FooterRow: React.FC<FooterRowProps> = ({
  page,
  setPage = () => null,
  setPageSize = () => null,
  pageSize = 10,
  total = 1,
}) => (
  <Box>
    <Flex direction="row-reverse">
      <Flex pos="sticky" right={16} w="fit-content" direction="row" gap={8 * 4}>
        <Box w="100px">
          <Select
            onChange={value => setPageSize(Number(value))}
            value={`${pageSize}`}
            data={['10', '25', '50', '100']}
          />
        </Box>
        <Pagination
          page={page}
          onChange={pageNumber => setPage(pageNumber)}
          total={total}
        />
      </Flex>
    </Flex>
  </Box>
);
